class branchDefaultValue {
    address:string = ''
    city_id:string = ''
    city_name:string = ''
    village:string = ''
    email:string = ''
    current_account_type_id:string = ''
    current_account_type_name:string = ''
    current_branch_diameter:string = ''
    current_contract_capacity:string = ''
    current_day:string = ''
    current_month:string = ''
    current_units_number:string = ''
    current_year:string = ''
    first_name:string = ''
    last_name:string = ''
    postal_code:string = ''
    previous_meter_number :string = ''
    previous_reading_date :string = ''

    constructor(branchDefaultValue?: any) {
        if(branchDefaultValue){
            this.address=branchDefaultValue.address
            this.city_id=branchDefaultValue.city_id
            this.city_name=branchDefaultValue.city_name
            this.village=branchDefaultValue.village
            this.current_account_type_id=branchDefaultValue.current_account_type_id
            this.current_account_type_name=branchDefaultValue.current_account_type_name
            this.current_branch_diameter=branchDefaultValue.current_branch_diameter
            this.current_contract_capacity=branchDefaultValue.current_contract_capacity
            this.current_day=branchDefaultValue.current_day
            this.current_month=branchDefaultValue.current_month
            this.current_units_number=branchDefaultValue.current_units_number
            this.current_year=branchDefaultValue.current_year
            this.first_name=branchDefaultValue.first_name
            this.last_name=branchDefaultValue.last_name
            this.email=branchDefaultValue.email
            this.postal_code=branchDefaultValue.postal_code
            this.previous_meter_number =branchDefaultValue.previous_meter_number
            this.previous_reading_date =branchDefaultValue.current_reading_date
        }

    }
}

export default branchDefaultValue;